<template>
    <div class="Show">
        <div>
            <van-nav-bar
                title="我的"
                left-text=""
                left-arrow
                @click-left="$router.back(-1)"
            />
            <div class="cmain">
                <div class="my_infos">
                    <div class="my_info"><span>会员账号</span><span>{{ myInfos.phoneNumber }}</span><div class="clearb"></div></div>
                    <div class="my_info"><span>会员昵称</span><span>{{ myInfos.name }}</span><div class="clearb"></div></div>
                    <div class="my_info"><span>会员等级</span><span>{{ myInfos.levelDesc }}</span><div class="clearb"></div></div>
                </div>
                <van-panel class="my_orders" title="我的订单">
                    <van-row class="user-links">
                    <van-col span="6" class="user_order">
                        <router-link to="/m/pendingpayment/1">
                            <van-icon name="pending-payment" />
                            待付款
                        </router-link>
                        <span class="corner" v-if="myOrderCout && myOrderCout.unpaidCount">{{myOrderCout && myOrderCout.unpaidCount}}</span>
                    </van-col>
                    <van-col span="6" class="user_order">
                        <router-link to="/m/pendingpayment/2">
                            <van-icon name="paid" />
                            待发货
                        </router-link>
                        <span class="corner" v-if="myOrderCout && myOrderCout.unDeliveredCount">{{myOrderCout && myOrderCout.unDeliveredCount}}</span>
                    </van-col>
                    <van-col span="6" class="user_order">
                        <router-link to="/m/pendingpayment/3">
                            <van-icon name="logistics" />
                            待收货
                        </router-link>
                        <span class="corner" v-if="myOrderCout && myOrderCout.unReceiveCount">{{myOrderCout && myOrderCout.unReceiveCount}}</span>
                    </van-col>
                    <van-col span="6">
                        <router-link to="/m/pendingpayment/0">
                            <van-icon name="records" />
                            所有订单
                        </router-link>
                    </van-col>
                </van-row>
                </van-panel>

                <van-cell-group class="user-group">
                    <van-cell icon="points" title="我的积分" :value="myInfos.integral" />
                    <van-cell icon="cash-back-record" title="我的现金券" :value="'$' + myInfos.cash" />
                    <van-cell icon="gold-coin-o" title="我的优惠券" value="" is-link @click="$router.push({path: '/m/myCouponsList'})" />
                </van-cell-group>
                <van-cell-group class="user-group">
                    <van-cell icon="user-o" title="个人资料" is-link @click="showMyUser()" />
                    <van-cell icon="envelop-o" title="我的收件人" is-link @click="showMyReceiptor()" />
                    <van-cell icon="edit" title="修改密码" is-link @click="popupIsShow = true" />
                </van-cell-group>
                <div class="loginout_btn_box">
                    <van-button type="danger" size="large" @click="loginout()">退出登录</van-button>
                </div>
                <div style="height: 50px;"></div>
            </div>
            <van-popup v-model="myUserIsShow" position="bottom">
                <van-nav-bar title="修改个人资料" left-text="" />
                <div class="cmain">
                    <van-cell-group>
                        <van-field
                            v-model="myUser.name"
                            clearable
                            label="昵称"
                            placeholder="请输入昵称"
                            :error-message="myUserError.name"
                            @keydown="myUserError.name=''"
                        />
                        <van-field
                            v-model="myUser.consignor.name"
                            clearable
                            label="寄件人"
                            placeholder="请输入寄件人姓名"
                            :error-message="myUserError.consignor.name"
                            @keydown="myUserError.consignor.name=''"
                        />
                        <van-field
                            v-model="myUser.consignor.tel"
                            clearable
                            label="电话"
                            placeholder="请输入电话"
                            :error-message="myUserError.consignor.tel"
                            @keydown="myUserError.consignor.tel=''"
                        />
                        <!--<van-field
                            v-model="myUser.emailAddress"
                            clearable
                            label="邮箱地址"
                            placeholder="请输入邮箱地址"
                            :error-message="myUserError.emailAddress"
                            @keydown="myUserError.emailAddress=''"
                        />-->
                    </van-cell-group>
                </div>
                <div class="loginout_btn_box">
                    <van-button type="primary" size="large" @click="updateMyUser()">确认修改资料</van-button>
                    <van-button type="default" size="large" @click="closeMyUser">关闭</van-button>
                </div>
            </van-popup>

            <van-popup v-model="popupIsShow" position="bottom">
                <van-nav-bar title="修改密码" left-text="" />
                <div class="cmain">
                    <van-cell-group>
                        <van-field
                            v-model="user.oldPassword"
                            clearable
                            type="password"
                            label="原密码"
                            placeholder="请输入原始密码"
                            :error-message="userError.oldPassword"
                            @keydown="userError.oldPassword=''"
                        />

                        <van-field
                            v-model="user.password"
                            clearable
                            type="password"
                            label="新密码"
                            placeholder="请输入密码"
                            :error-message="userError.password"
                            @keydown="userError.password=''"
                        />
                        <van-field
                            v-model="user.confirmPassword"
                            clearable
                            type="password"
                            label="确认密码"
                            placeholder="请再次输入密码"
                            :error-message="userError.confirmPassword"
                            @keydown="userError.confirmPassword=''"
                        />
                    </van-cell-group>
                </div>
                <div class="loginout_btn_box">
                    <van-button type="primary" size="large" @click="updatePassword()" v-if="!updateLoading">确认修改密码</van-button>
                    <van-button loading type="primary" disabled  size="large" loading-text="提交修改中..." v-if="updateLoading" />
                    <van-button type="default" size="large" @click="closeUpdatePwd">关闭</van-button>
                </div>
            </van-popup>

            <cpnpeceiptor :isChoiseReceiptor="receiptorDialogVisible"
                v-on:choisedReceiptor="choiseReceiptor" v-on:closeRecPopup="closeRecPopup"></cpnpeceiptor>
        </div>
    </div>
</template>

<script>
    import { Row, Col, Panel } from 'vant';
    import cpnpeceiptor from '@/views/m/components/receiptor.vue'
    export default {
        name: "MyInfo",
        components: {
            cpnpeceiptor,
            [Row.name]: Row,
            [Col.name]: Col,
            [Panel.name]: Panel
        },
        data() {
            return {
                popupIsShow: false,
                updateLoading: false,
                myInfos: {},
                //修改资料
                myUserIsShow: false,
                myUser: {
                    "name": "",
                    "emailAddress": "",
                    "consignor": {
                        "name": "",
                        "tel": ""
                    }
                },
                myUserError: {
                    "name": "",
                    "emailAddress": "",
                    "consignor": {
                        "name": "",
                        "tel": ""
                    }
                },
                //修改密码
                user: {
                    oldPassword: "",
                    password: "",
                    confirmPassword: ""
                },
                userError: {
                    oldPassword: "",
                    password: "",
                    confirmPassword: ""
                },
                receiptorDialogVisible: false, //联系人
                myOrderCout: {}
            }
        },
        mounted() {
            this.getMyInformation()
            this.getMyOrderCout()
        },
        methods: {
            getMyInformation() {
                this.$axios.get(window.consts.apis.getMyInfo, {}).then(r=>{
                    if(r.success){
                        this.myInfos = r.result;
                    } else {
                        this.$toast.fail("加载数据失败!")
                    }
                }, error => {
                    this.$toast.fail("加载数据失败!")
                })
            },
            getMyOrderCout() {
                this.$axios.post(window.consts.apis.queryMyOrderCout).then(r=>{
                    if(r.success){
                        this.myOrderCout = r.result;
                    } else {
                        this.$toast.fail("加载数据失败!")
                    }
                }, error => {
                    this.$toast.fail("加载数据失败!")
                })
            },
            closeUpdatePwd() {
                this.popupIsShow = false
                this.updateLoading = false
                this.user.oldPassword = ""
                this.user.password = ""
                this.user.confirmPassword = ""
            },
            updatePassword() {
                var valid = window.consts.validate
                if(!valid.password.test(this.user.oldPassword)) {
                    this.userError.oldPassword = "原密码格式不正确!"
                    return false
                } else if (!valid.password.test(this.user.password)) {
                    this.userError.password = "新密码格式不正确!"
                    return false
                } else if (this.user.password != this.user.confirmPassword) {
                    this.userError.confirmPassword ="两次密码不一致!"
                    return false
                }
                this.updateLoading = true
                this.$axios.put(window.consts.apis.password, this.user).then(res => {
                    this.updateLoading = false
                    if (res.success) {
                        var toast = this.$toast.loading({
                            duration: 0,
                            forbidClick: true,
                            loadingType: 'spinner',
                            message: '3秒后退出',
                            onClose: (rt => {
                                this.$store.dispatch('userLogout');
                                localStorage.removeItem(window.consts.strings.userToken)
                                this.$router.push({ path: '/m/login' })
                            })
                        });
                        let second = 3;
                        const timer = setInterval(() => {
                            second--;
                            if (second) {
                                toast.message = `${second}秒后退出`;
                            } else {
                                clearInterval(timer);
                                this.$toast.clear();
                            }
                        }, 1000);
                    } else {
                        this.$toast.fail("修改密码失败!")
                    }
                }, error => {
                    this.updateLoading = false
                    this.$toast.fail("修改密码失败!")
                })
            },
            showMyUser() {
                this.myUser.name = this.myInfos.name;
                this.myUser.emailAddress = this.myInfos.emailAddress;
                this.myUser.consignor.name = this.myInfos.consignor.name;
                this.myUser.consignor.tel = this.myInfos.consignor.tel;
                this.myUserIsShow = true
            },
            updateMyUser() {
                var valid = window.consts.validate
                if(!this.myUser.name) {
                    this.myUserError.name = "请输入昵称!"
                    return false
                } else if (!this.myUser.consignor.name) {
                    this.myUserError.consignor.name = "请输入寄件人姓名!"
                    return false
                } else if(!this.myUser.consignor.tel) {
                    this.myUserError.consignor.tel = "电话号码格式错误!"
                    return false
                } 
                /*else if (!valid.email.test(this.myUser.emailAddress)) {
                    this.myUserError.emailAddress = "邮箱地址格式错误!"
                    return false
                }*/
                this.showLoading();

                this.$axios.put(window.consts.apis.updateMyInfo, this.myUser).then(res => {
                    this.hideLoading();
                    if (res.success) {
                        this.$toast.success({
                            duration: 2000,
                            forbidClick: true,
                            loadingType: 'spinner',
                            message: "资料修改成功!",
                            onClose: (rt => {
                                this.getMyInformation();
                                this.closeMyUser();
                            })
                        });
                    } else {
                        this.$dialog.alert({ message: res.error.message });
                    }
                }).catch(e => {
                    this.$toast.fail("出错啦，请稍候再试!");
                    this.hideLoading();
                })
            },
            closeMyUser() {
                this.myUserError.name = "";
                this.myUserError.emailAddress = "";
                this.myUserError.consignor.name = "";
                this.myUserError.consignor.tel = "";
                this.myUserIsShow = false;
            },
            showMyReceiptor() {
                this.receiptorDialogVisible = true;
            },
            choiseReceiptor(item) {
                return false;
            },
            closeRecPopup(data) {
                this.receiptorDialogVisible = data;
            },
            loginout() {
                this.$dialog.confirm({
                    message: '确定要退出吗？'
                }).then(() => {
                    this.$store.dispatch('userLogout');
                    localStorage.removeItem(window.consts.strings.userToken)
                    location.reload();
                }).catch(() => {
                    
                });
            },
            showLoading() {
                this.$toast.loading({
                    duration: 0,
                    forbidClick: true,
                    loadingType: 'spinner',
                    message: '加载中...'
                });
            },
            hideLoading() {
                this.$toast.clear()
            }
        }
    };
</script>

<style lang="scss" scoped>
    .user {
        &-poster {
            width: 100%;
            height: 53vw;
            display: block;
        }
        &-group {
            margin-top: 10px;
            .van-cell__value span { color: red;}
        }
        &-links {
            padding: 15px 0;
            font-size: 14px;
            text-align: center;
            background-color: #fff;
            a { color: #000;}
            .van-icon {
                display: block;
                font-size: 32px;
                margin-bottom: 2px;
                color: #999;
            }
            
        }
    }
    .my {
        &_infos {
            padding:10px 15px;
            background:#fff;
            margin:10px auto; 
        }
        &_info {
            padding:5px 0;
        }
        &_info {
            span:nth-child(odd) { float: left;}
            span:nth-child(even) { float: right;}
        }
        &_orders {
            .van-cell__title {
                font-size: 16px;
                font-weight: bold;
                color: #576b95;
            }
            .user_order {
                position: relative;
            }
            .corner {
                display: block;
                margin-left: 8px;
                width: 16px;
                height: 16px;
                line-height: 16px;
                text-align: center;
                border-radius: 16px;
                font-size: 12px;
                overflow: hidden;
                background: red;
                color: #fff;
                position: absolute;
                top: 0;
                left: 50%;
            }
        }
    }
    .loginout_btn_box {
        width: 96%;
        margin:10px auto 0;
        button {
            margin:0 auto 10px;
        }
    }
    .van-popup {
        height:100%;
    }
</style>
